import React, {memo} from "react";
import PropTypes from "prop-types";
import "./style.scss";

export default memo(function CardView({ title, imgUrl }) {
  CardView.propTypes = {
    title: PropTypes.string,
    imgUrl: PropTypes.string,
  };
  return (
    <div className="insight-card-view">
      {imgUrl && <img src={imgUrl} alt="" />}
      {title && <div className="insight-card-view__title">{title}</div>}
    </div>
  );
});
